import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {storeToRefs} from 'pinia';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';
import {useUserStore} from '../../stores/userStore';
import {handleFeatureFlagGuard} from './featureFlagGuard';

export async function beforeEnterVisitorManagement(
    _to: RouteLocationNormalized,
    from: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const {isVisitorManager} = storeToRefs(useUserStore());
    if (!isVisitorManager.value) {
        return {name: 'Home'};
    }

    const {visitorManagement} = storeToRefs(useFeatureFlagStore());

    return await handleFeatureFlagGuard(visitorManagement, from);
}
